import AppRoutes from "routes/AppRoutes";
import AuthInitializer from "services/auth/AuthInitializer";

export default function App() {
    return (
        <AuthInitializer>
            <AppRoutes />
        </AuthInitializer>
    );
}
